module.exports = __webpack_public_path__ + "img/empty-file.48b46dd8.svg";